var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext } from 'react';
import { SortContext } from '../../Table/utils/Sort/SortContext';
import { StyledTableHeadCell } from './styled';
export function TableHeadCell(props) {
    const { children, stickyColumn, maxWidth } = props, rest = __rest(props, ["children", "stickyColumn", "maxWidth"]);
    const { hideColRows } = useContext(SortContext) || {};
    const hide = Boolean(hideColRows === null || hideColRows === void 0 ? void 0 : hideColRows.find((colRow) => colRow === (rest === null || rest === void 0 ? void 0 : rest.id)));
    return (<StyledTableHeadCell $hide={hide} $stickyColumn={stickyColumn} data-sticky-column={stickyColumn} $maxWidth={maxWidth} {...rest}>
      {children}
    </StyledTableHeadCell>);
}
